import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

const SOFTWARE_FILTERS = ['Vectric', 'Carveco', 'LightBurn', 'Others'];

function SoftwareFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu label="Software" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('softwareUsed')}>
        All
      </DropdownMenuItem>
      {SOFTWARE_FILTERS.map((sw) => (
        <DropdownMenuItem
          key={sw}
          onClick={() => appendSearchParam('softwareUsed', sw)}
        >
          {sw}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default SoftwareFilter;
